import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { queryStringToObject, validationErrorsToString } from '../../utils';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

// COMPONENTS
import CertificationStaff from './Staff/CertificationStaff';
import CertificationParent from './Parent/CertificationParent';
import CertificationVisitor from './Visitor/certificationVisitor';
import CertificationStudent from './Student/CertificationStudent';

// TYPES
import { OrganisationFindOrganisationSummary } from '../../api/models';

interface AddCertificationTypes {}

export const AddCertification: React.FC<AddCertificationTypes> = ({}) => {
	const location = useLocation();

	const [showError, setShowError] = React.useState<boolean>(false);

	const [formErrorMessage, setFormErrorMessage] = React.useState<string>();

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const lists = useAppSelector((state) => state.lists);

	const [profile, setProfile] = React.useState<{ label?: string; value?: string } | undefined>();

	const [organisation, setOrganisation] = React.useState<OrganisationFindOrganisationSummary | undefined>();

	const [paramsSuccess, setParamsSuccess] = React.useState<boolean>(false);

	//Get Organisation ID and TYPE
	const checkLocationParams = async () => {
		setFormErrorMessage('');

		setShowError(false);

		const locationParams = location.state;

		const queryParams = queryStringToObject();

		// merge in location state and query string
		// short names in query string, id becomes organisationIdentifier, type becomes profileType
		const params = {
			organisationIdentifier: queryParams.id || undefined,

			profileType: queryParams.type || undefined,

			...locationParams
		};

		setIsLoading(true);

		if (params.organisationIdentifier && params.profileType) {
			const selectedProfile =
				lists?.profileTypes?.filter((item) => item.value?.toLowerCase() === params.profileType?.toLowerCase())[0] ||
				undefined;

			if (selectedProfile) {
				setProfile(selectedProfile);
			}

			const response = await apibridge.getOrganisationByIdentifier(params.organisationIdentifier);

			if (response.isError) {
				setIsLoading(false);

				setShowError(true);

				setFormErrorMessage(
					response.validationErrors.length
						? validationErrorsToString(response.validationErrors)
						: response.message || 'An error has occurred'
				);
			} else if (response.result) {
				setShowError(false);

				setIsLoading(false);

				setOrganisation({
					...response.result
				});

				setParamsSuccess(true);
			} else {
				setShowError(false);

				setIsLoading(false);
			}

			setIsLoading(false);
		}
	};

	React.useEffect(() => {
		if (lists) {
			checkLocationParams();
		}
	}, [lists]);

	if (showError) {
		return <div className="form-validation-error">{formErrorMessage}</div>;
	} else {
		return (
			<>
				{profile?.value === 'Staff' ? (
					<CertificationStaff organisationData={organisation} profileData={profile} />
				) : profile?.value === 'Parent' ? (
					<CertificationParent organisationData={organisation} profileData={profile} />
				) : profile?.value === 'Visitor' ? (
					<CertificationVisitor organisationData={organisation} profileData={profile} />
				) : profile?.value === 'Student' ? (
					<CertificationStudent organisationData={organisation} profileData={profile} />
				) : (
					<Link className="btn-primary submit-btn m-auto" to="/find-organisation">
						Join an Organisation
					</Link>
				)}
			</>
		);
	}
};

export default AddCertification;
